/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ valueNumber: NonNullable<unknown>, targetText: NonNullable<unknown> }} Exercise_Personal_Goal_ProgressInputs */

const en_us2_exercise_personal_goal_progress = /** @type {(inputs: Exercise_Personal_Goal_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueNumber} of ${i?.targetText}`)
};

const pt_br2_exercise_personal_goal_progress = /** @type {(inputs: Exercise_Personal_Goal_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueNumber} de ${i?.targetText}`)
};

const es_419_exercise_personal_goal_progress = /** @type {(inputs: Exercise_Personal_Goal_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueNumber} de ${i?.targetText}`)
};

const pt_pt2_exercise_personal_goal_progress = /** @type {(inputs: Exercise_Personal_Goal_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueNumber} de ${i?.targetText}`)
};

const fr_fr2_exercise_personal_goal_progress = /** @type {(inputs: Exercise_Personal_Goal_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueNumber} sur ${i?.targetText}`)
};

const de_de2_exercise_personal_goal_progress = /** @type {(inputs: Exercise_Personal_Goal_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueNumber} von ${i?.targetText}`)
};

const it_it2_exercise_personal_goal_progress = /** @type {(inputs: Exercise_Personal_Goal_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueNumber} di ${i?.targetText}`)
};

/**
* | output |
* | --- |
* | "{valueNumber} of {targetText}" |
*
* @param {Exercise_Personal_Goal_ProgressInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_progress = /** @type {((inputs: Exercise_Personal_Goal_ProgressInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_ProgressInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_progress(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_progress(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_progress(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_progress(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_progress(inputs)
	return en_us2_exercise_personal_goal_progress(inputs)
});
export { exercise_personal_goal_progress as "exercise-personal.goal_progress" }